/** */
import { urls } from '../_url';
import { apiPost } from '../_http';

/** */
const base_url = `${urls.ai}/v1/chats`;

export const chat = async (options = {}) => {
  return await apiPost(`${base_url}/`, { ...options });
};
